/*
* 动态列的数据 
*/
export const COLUMNS = [{
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "unitsOrdered",
    title: "销量",
    field: "unitsOrdered",
    minWidth: "120px",
    default: true,
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'unitsOrdered'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "multiChannelOrders",
    title: "多渠道销量",
    field: "multiChannelOrders",
    minWidth: "120px",
    default: true,
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'multiChannelOrders'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku'],
    id: "orders",
    title: "订单量",
    field: "orders",
    minWidth: "120px",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "订单中存在多个商品时，合计栏不会重复统计"
    },
    sortable: true,
    slots: {
      default: 'orders'
    }
  },
  {
    includesType: ['shop'],
    id: "orders-shop",
    title: "订单量",
    field: "orders",
    minWidth: "120px",
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'orders'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "returns",
    title: "退货量",
    field: "returns",
    minWidth: "120px",
    default: true,
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'returns'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "returnsRate",
    title: "退货率",
    field: "returnsRate",
    minWidth: "120px",
    suffix: "%",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "退货率=退货量/销量；按订单退货时间统计"
    },
    sortable: true,
    slots: {
      default: 'returnsRate'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "refunds",
    title: "退款量",
    field: "refunds",
    minWidth: "120px",
    default: true,
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'refunds'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "refundsRate",
    title: "退款率",
    field: "refundsRate",
    minWidth: "120px",
    suffix: "%",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "退款率=退款量/销量；按订单退款时间统计"
    },
    sortable: true,
    slots: {
      default: 'refundsRate'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "orderProductSales",
    title: "销售额",
    field: "orderProductSales",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'orderProductSales'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "purchaseCost",
    title: "采购成本",
    field: "purchaseCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "arriveCost",
    title: "到库成本",
    field: "arriveCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "shippingCost",
    title: "FBA配送费",
    field: "shippingCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "commissionCost",
    title: "销售佣金",
    field: "commissionCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "discountCost",
    title: "促销折扣",
    field: "discountCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'discountCost'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "shippingPrice",
    title: "买家运费",
    field: "shippingPrice",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "platformCost",
    title: "平台费用",
    field: "platformCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'platformCost'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "vatPrice",
    title: "VAT费用",
    field: "vatPrice",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "otherExpensesCost",
    title: "其他",
    field: "otherExpensesCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "multichannelDeductionCost",
    title: "多渠道扣费",
    field: "multichannelDeductionCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "refundCost",
    title: "订单退款",
    field: "refundCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "returnsCost",
    title: "退货补回成本",
    field: "returnsCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "bogusCost",
    title: "推广订单费用",
    field: "bogusCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true
  },
  {
    includesType: ['asin', 'variationAsin', 'msku'],
    id: "adsSpend",
    title: "广告花费",
    field: "adsSpend",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "仅包含商品广告、展示广告的费用，不包含品牌广告的费用"
    },
    sortable: true,
    slots: {
      default: 'adsSpend'
    }
  },
  {
    includesType: ['shop'],
    id: "adsSpend-shop",
    title: "广告花费",
    field: "adsSpend",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "包含商品广告、展示广告、品牌广告的费用"
    },
    slots: {
      default: 'adsSpend'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "storageCost",
    title: "仓储费",
    field: "storageCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "仅按月份查询时有数据统计"
    },
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "salesGrossProfit",
    title: "销售毛利",
    field: "salesGrossProfit",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "销售毛利=销售额+采购成本+到库成本+FBA配送费+销售佣金+促销折扣+买家运费+平台费+VAT费用+其他+多渠道扣费+订单退款+退货补回成本+推广订单费用"
    },
    sortable: true,
    slots: {
      default: 'salesGrossProfit'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "grossProfitRate",
    title: "销售毛利率",
    field: "grossProfitRate",
    minWidth: "120px",
    default: true,
    suffix: "%",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "销售毛利率=销售毛利/销售额"
    },
    sortable: true,
    slots: {
      default: 'grossProfitRate'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "salesNetProfit",
    title: "销售净毛利",
    field: "salesNetProfit",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "销售净毛利=销售毛利+广告花费+仓储费"
    },
    sortable: true,
    slots: {
      default: 'salesNetProfit'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "salesNetProfitRate",
    title: "销售净毛利率",
    field: "salesNetProfitRate",
    minWidth: "150px",
    default: true,
    suffix: "%",
    summary: true,
    align: 'right',
    titleHelp: {
      message: "销售净毛利率=销售净毛利/销售额"
    },
    sortable: true,
    slots: {
      default: 'salesNetProfitRate'
    }
  },
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: 'realOrderProductSales',
    title: '实际销售额',
    field: 'realOrderProductSales',
    width: '140px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: "实际销售额=销售额-促销折扣"
    },
    summary: true,
    default: true,
    slots: {
      default: 'realOrderProductSales'
    }
  },
 
]


export const COLUMNS_2 = [
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "unitsOrdered", header: "销量", field: "slot:unitsOrdered", minWidth: "120px", default: true, summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "multiChannelOrders", header: "多渠道销量", field: "slot:multiChannelOrders", minWidth: "120px", default: true, summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku'],          id: "orders", header: "订单量", field: "slot:orders", minWidth: "120px", summary: true, align: 'right', help:"订单中存在多个商品时，合计栏不会重复统计", sortable: true},
  {includesType: ['shop'],                                   id: "orders-shop", header: "订单量", field: "slot:orders", minWidth: "120px", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "returns", header: "退货量", field: "slot:returns", minWidth: "120px", default: true, summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "returnsRate", header: "退货率", field: "slot:returnsRate", minWidth: "120px", suffix: "%", summary: true, align: 'right', help:"退货率=退货量/销量；按订单退货时间统计", sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "refunds", header: "退款量", field: "slot:refunds", minWidth: "120px", default: true, summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "refundsRate", header: "退款率", field: "slot:refundsRate", minWidth: "120px", suffix: "%", summary: true, align: 'right', help:"退款率=退款量/销量；按订单退款时间统计", sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "orderProductSales", header: "销售额", field: "slot:orderProductSales", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "purchaseCost", header: "采购成本", field: "purchaseCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "arriveCost", header: "到库成本", field: "arriveCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "shippingCost", header: "FBA配送费", field: "shippingCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "commissionCost", header: "销售佣金", field: "commissionCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "discountCost", header: "促销折扣", field: "slot:discountCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "shippingPrice", header: "买家运费", field: "shippingPrice", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: "platformCost",
    header: "平台费用",
    field: "slot:platformCost",
    minWidth: "120px",
    default: true,
    prefix: "currencySymbol",
    summary: true,
    align: 'right',
    sortable: true,
    slots: {
      default: 'platformCost'
    }
  },
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "vatPrice", header: "VAT费用", field: "vatPrice", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "otherExpensesCost", header: "其他", field: "otherExpensesCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "multichannelDeductionCost", header: "多渠道扣费", field: "multichannelDeductionCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "refundCost", header: "订单退款", field: "refundCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "returnsCost", header: "退货补回成本", field: "returnsCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "bogusCost", header: "推广订单费用", field: "bogusCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku'],          id: "adsSpend", header: "广告花费", field: "slot:adsSpend", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', help:"仅包含商品广告、展示广告的费用，不包含品牌广告的费用", sortable: true},
  {includesType: ['shop'],                                   id: "adsSpend-shop", header: "广告花费", field: "slot:adsSpend", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', help:"仅包含商品广告、展示广告的费用，不包含品牌广告的费用"},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "storageCost", header: "仓储费", field: "storageCost", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', help:"仅按月份查询时有数据统计"},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "salesGrossProfit", header: "销售毛利", field: "slot:salesGrossProfit", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', help:"销售毛利=销售额+采购成本+到库成本+FBA配送费+销售佣金+促销折扣+买家运费+平台费+VAT费用+其他+多渠道扣费+订单退款+退货补回成本+推广订单费用", sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "grossProfitRate", header: "销售毛利率", field: "slot:grossProfitRate", minWidth: "120px", default: true, suffix: "%", summary: true, align: 'right', help:"销售毛利率=销售毛利/销售额", sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "salesNetProfit", header: "销售净毛利", field: "slot:salesNetProfit", minWidth: "120px", default: true, prefix: "currencySymbol", summary: true, align: 'right', help:"销售净毛利=销售毛利+广告花费+仓储费", sortable: true},
  {includesType: ['asin', 'variationAsin', 'msku', 'shop'],  id: "salesNetProfitRate", header: "销售净毛利率", field: "slot:salesNetProfitRate", minWidth: "140px", default: true, suffix: "%", summary: true, align: 'right', help:"销售净毛利率=销售净毛利/销售额", sortable: true},
  {
    includesType: ['asin', 'variationAsin', 'msku', 'shop'],
    id: 'realOrderProductSales',
    header: '实际销售额',
    field: 'slot:realOrderProductSales',
    width: '140px',
    sortable: true,
    align: 'right',
    help: '实际销售额=销售额-促销折扣',
    summary: true,
    default: true
  },
]



export const loop_fields = [
  // 销售数据
   { id: 'unitsOrdered', header: '销量', field: 'unitsOrdered'},
   { id: 'multiChannelOrders', header: '多渠道销量', field: 'multiChannelOrders' },
   { id: 'orders', header: '订单量', field: 'orders' },
   { id: 'discountCost', header: '促销折扣', field: 'discountCost', prefix: 'currencySymbol' },
   { id: 'orderProductSales', header: '销售额', field: 'orderProductSales', prefix: 'currencySymbol'},
   { id: 'realOrderProductSales', header: '实际销售额', field: 'realOrderProductSales',  prefix: 'currencySymbol'},
   { id: 'returns', header: '退货量', field: 'returns' },
   { id: 'returnsRate', header: '退货率', field: 'returnsRate', suffix: '%'},
   { id: 'refunds', header: '退款量', field: 'refunds' },
   { id: 'refundsRate', header: '退款率', field: 'refundsRate',  suffix: '%' },
  // 广告数据
  { id: 'adsSpend', header: '广告花费', field: 'adsSpend', prefix: 'currencySymbol'},
  // 利润数据
  { id: 'salesGrossProfit', header: '销售毛利', field: 'salesGrossProfit',  prefix: 'currencySymbol' } ,
  { id: 'grossProfitRate', header: '销售毛利率', field: 'grossProfitRate',  suffix: '%' } ,
  { id: 'salesNetProfit', header: '销售净毛利', field: 'salesNetProfit',  prefix: 'currencySymbol' } ,
  { id: 'salesNetProfitRate', header: '销售净毛利率',  field: 'salesNetProfitRate',  suffix: '%' } ,
];

